import React, { useEffect, useRef } from 'react';
import { useAuthWizardContext } from 'providers/AuthWizardProvider';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import celebration from './lottie/celebration.json';

const Success = ({ reset, onSubmit }) => {
  const { setStep, setUser } = useAuthWizardContext();
  const hasSubmitted = useRef(false);

  // Trigger form submission when component mounts (only once)
  useEffect(() => {
    if (onSubmit && !hasSubmitted.current) {
      hasSubmitted.current = true;
      onSubmit();
    }
  }, [onSubmit]);

  const emptyData = () => {
    setStep(1);
    setUser({});
    reset();
  };

  return (
    <>
      <Row>
        <Col className="text-center">
          <div className="wizard-lottie-wrapper">
            <div className="wizard-lottie mx-auto">
              <Lottie animationData={celebration} loop={true} />
            </div>
          </div>
          <h4 className="mb-1">User profile is all set!</h4>
          <p className="fs-9">That user is ready to access their account</p>
          <Button color="primary" className="px-5 my-3" onClick={emptyData}>
            Sign Up another
          </Button>
        </Col>
      </Row>
    </>
  );
};

Success.propTypes = {
  reset: PropTypes.func.isRequired,
  onSubmit: PropTypes.func
};

export default Success;
